import script from "./CreateWork.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateWork.vue?vue&type=script&setup=true&lang=ts"

import "./CreateWork.vue?vue&type=style&index=0&id=56fde2b8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56fde2b8"]])

export default __exports__